<template>
  <v-dialog v-model="show" persistent max-width="550" :retain-focus="false">
    <v-card data-cy="modal-finalize-offer">
      <v-card-title class="text-h3">{{ $t('FINALIZE_OFFER_MODAL_TITLE') }}</v-card-title>

      <v-card-text class="text-body-2 mt-4 mb-4">
        {{ $t('FINALIZE_OFFER_MODAL_DESCRIPTION') }}
      </v-card-text>

      <v-card-actions class="d-flex justify-end pa-4">
        <v-btn
          class="link non-text-transformation"
          id="cancel"
          color="black"
          outlined
          tile
          @click="$emit('cancelFinalizeOffer')"
        >
          {{ $t('FINALIZE_OFFER_MODAL_CANCEL') }}
        </v-btn>

        <v-btn
          class="link non-text-transformation"
          id="submit"
          color="primary"
          tile
          @click="$emit('confirmFinalizeOffer')"
        >
          {{ $t('FINALIZE_OFFER_MODAL_CONTINUE') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'FinalizeOfferDialog',
  props: {
    show: {
      type: Boolean,
      required: true,
    },
  },
}
</script>
